export enum OvertimesSummaryChartDisplayMode {
  SUMMARY = 0,
  SUMMARY_PER_WORKER = 1,
  DAILY = 2,
  WEEKLY = 3,
  MONTHLY = 4,
}
